import { render } from "./PaymentContent.vue?vue&type=template&id=062e5694"
import script from "./PaymentContent.vue?vue&type=script&lang=js"
export * from "./PaymentContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__